namespace e5{
    export interface BlobLoaderOptions extends AjaxLoaderOptions {

    }

    class BlobLoader extends AbstractAjaxLoader<Blob, BlobLoaderOptions>{
        protected defaultOptions(): BlobLoaderOptions {
            return {
                decoder: "blob"
            }
        }
    }

    export interface LoaderOptionsMap {
        "blob": BlobLoaderOptions;
    }
    
    export interface LoaderMap {
        "blob": BlobLoader;
    }

    registerLoader("blob", BlobLoader);
}